/* eslint-disable @typescript-eslint/naming-convention */
import { Injector, runInInjectionContext } from '@angular/core';
import { EditIrisIdDialogService } from '../dialogs';

import { irisIdData } from '../types';

export function prepareEditIRISIdData<T extends object>(iData: T) {
  const pData = {};
  if (iData) {
    if ('id' in iData) {
      Object.assign(pData, { id: iData.id });
    }
    if ('first_name' in iData && 'last_name' in iData) {
      Object.assign(pData, { name: `${iData.first_name} ${iData.last_name}` });
    }
    if ('email' in iData) {
      Object.assign(pData, { email: iData.email });
    }
    if ('legacy_id' in iData) {
      Object.assign(pData, { legacy_id: iData.legacy_id });
    }
    if ('data' in iData) {
      if (iData.data instanceof Object) {
        if ('additional_legacy_ids' in iData.data) {
          Object.assign(pData, {
            additional_legacy_ids: iData.data.additional_legacy_ids,
          });
        }
      }
    }
  }
  return pData && (pData as irisIdData);
}

export function editIRISIdMenu(injector: Injector, data: irisIdData) {
  return runInInjectionContext(injector, () => {
    const _editIrisIdDialogService = injector.get(EditIrisIdDialogService);
    return {
      callback: () =>
        _editIrisIdDialogService.openUserManagementDialog({ ...data }),
      title: 'Edit IRIS ID',
    };
  });
}
